export default function CTASection() {
  return (
    <section className="relative py-20 md:py-28 overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Warm%20minimalist%20lifestyle%20scene%20of%20a%20serene%20home%20office%20corner%20with%20a%20laptop%20on%20a%20light%20oak%20desk%20surrounded%20by%20carefully%20curated%20fashion%20magazines%20a%20ceramic%20vase%20with%20dried%20pampas%20grass%20and%20a%20wool%20throw%20draped%20over%20a%20linen%20chair%20soft%20golden%20hour%20sunlight%20streaming%20through%20large%20windows%20creating%20long%20gentle%20shadows%20editorial%20interior%20design%20aesthetic%20calm%20sophisticated%20atmosphere&width=1800&height=900&seq=cta-bg-v2-superbuy-18&orientation=landscape"
          alt="Superbuy Spreadsheet - Start managing your international shopping today"
          title="Superbuy Spreadsheet - Get Started Now"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/40 to-black/55"></div>
      </div>

      <div className="relative z-10 max-w-3xl mx-auto px-4 md:px-6 text-center">
        <h2 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-white tracking-wide mb-4">
          READY TO SHOP SMARTER?
        </h2>
        <p className="text-white/75 text-sm md:text-base max-w-lg mx-auto leading-relaxed mb-10">
          Stop managing your international purchases with scattered notes and guesswork. Get the complete Superbuy Spreadsheet system and take control of every order.
        </p>

        <a
          href="https://kaspreadsheet.com"
          target="_blank"
          rel="noopener nofollow"
          className="group inline-flex items-center gap-3 px-8 py-4 bg-black text-white text-sm md:text-base font-semibold rounded-full hover:bg-foreground-800 transition-all duration-300 whitespace-nowrap cursor-pointer"
        >
          <span className="w-8 h-8 rounded-full bg-primary-500 flex items-center justify-center flex-shrink-0">
            <i className="ri-shopping-bag-line text-white text-sm"></i>
          </span>
          <span>Explore Main Website</span>
          <div className="w-4 h-4 flex items-center justify-center">
            <i className="ri-arrow-right-up-line text-white/60 text-sm group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform duration-200"></i>
          </div>
        </a>
      </div>
    </section>
  );
}